module.exports = __webpack_public_path__ + "img/postcard.d4f867dc.png";